module.exports = __webpack_public_path__ + "img/00043.374c2aff.webp";